import { useQueryClient } from '@tanstack/react-query';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { usePlayerStore } from '../store/player.store';
import { useAnalyticsReporter, useStore } from '../store/store';

export function useSignOut() {
  const queryClient = useQueryClient();
  const analytics = useAnalyticsReporter();
  const navigate = useNavigate();
  const [resetStore] = useStore(useShallow(state => [state.reset]));
  const [resetPlayer] = usePlayerStore(useShallow(state => [state.reset]));

  const signOut = async () => {
    queryClient.clear();
    await getAuth().signOut();
    analytics.reset();
    resetPlayer();
    resetStore();

    navigate('/');
    location.reload();
  };

  return signOut;
}
